export const formatResponseDate = (dateResponse: string | Date) => {
  const date = new Date(dateResponse);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  return `${month}/${day}/${year}`;
};
